export class API{
    public static prodBaseURL = "https://galaxy-api.clevernav.ai";
}